import * as React from 'react';
import { useContext } from 'react';

import type { BrowseDomainList_DomainFragment as Domain } from 'bundles/page-config-common/queries/__generated__/BrowseDomainListQuery';

export type DomainListContextType = {
  domains?: Domain[];
};

const DomainListContext = React.createContext<DomainListContextType | undefined>(undefined);

export const useDomainList = () => {
  return useContext(DomainListContext);
};

export default DomainListContext;
